import type { ReportCategories } from '../../../../common/enums/reportCategories';
import type { IRequestGetOne } from '../../interfaces/requestGetOne';
import { translateKey } from '../../../translate';
import { AssignToColleagueModal } from '../AssignToColleagueModal';
import { Button } from '../common';
import { Component } from '../Component';

interface IAssignProcessToColleagueButtonProps {
    addReport?: (reportCategory: ReportCategories.consultReport) => Promise<void>;
    assignProcessColleague: () => Promise<void>;
    request: IRequestGetOne;
}

export class AssignProcessToColleagueButton extends Component<
    IAssignProcessToColleagueButtonProps,
    { showModal?: boolean }
> {
    public render() {
        if (
            !this.props.request.authorization ||
            !this.props.request.authorization.canAssignToColleague ||
            !this.props.addReport
        ) {
            return null;
        }

        return (
            <>
                <Button
                    color="secondary"
                    large
                    onClick={async () => await this.setState({ showModal: true })}
                    outlined
                >
                    {translateKey('request.assignTo') + ' ' + translateKey('common.colleague')}
                </Button>

                {this.state.showModal && (
                    <AssignToColleagueModal
                        onAssign={async () => {
                            await this.setState({ showModal: false });
                            await this.props.assignProcessColleague();
                        }}
                        onClose={async () => await this.setState({ showModal: false })}
                        request={this.props.request}
                    />
                )}
            </>
        );
    }
}
